import React from 'react'
import mark from '../assets/images/brand/logo-mark.png'
import wordmarkBlue from '../assets/images/brand/wordmark-blue.png'
import wordmarkWhite from '../assets/images/brand/wordmark-white.png'

// Brand logo, cropped from public/Poultryfy_logo*.png into mark + wordmark so
// it can sit on one line in the header. `light` is for dark backgrounds.
const Logo = ({ light = false }) => (
    <span className="brand">
        <img className="brand-mark" src={mark} alt="" width="40" height="40" />
        <img className="brand-word" src={light ? wordmarkWhite : wordmarkBlue} alt="Poultryfy" width="117" height="24" />
    </span>
)

export default Logo
